import type {ReactElement} from 'react';
import React, {useRef} from 'react';
import type {AvatarPlaceholderIconProps} from '@Components/avatar-placeholder-icon/avatar-placeholder-icon.types';
import {AvatarBorderThickness, AvatarPlaceholderColorClass, AvatarSize} from '@Components/avatar-placeholder-icon/avatar-placeholder-icon.types';
import {Text, TextSize} from '@Components/text';
import styles from './avatar-placeholder-icon.module.scss';

export function AvatarPlaceholderIcon({
  placeholderLetter,
  colorClass = AvatarPlaceholderColorClass.PRIMARY_100,
  size = AvatarSize.MEDIUM,
  isRandomColor = false,
  borderThickness = AvatarBorderThickness.THICK,
}: AvatarPlaceholderIconProps): ReactElement<any> {
  const getRandomColor = (): AvatarPlaceholderColorClass => {
    const colourValues = Object.values(AvatarPlaceholderColorClass);
    const randomIndex = Math.floor(Math.random() * colourValues.length);
    return colourValues[randomIndex];
  };

  const randomColorRef = useRef<AvatarPlaceholderColorClass>(getRandomColor());

  const getSizeClass = (): string => {
    switch (size) {
      case AvatarSize.XSMALL:
        return styles.xsmall;
      case AvatarSize.SMALL:
        return styles.small;
      case AvatarSize.LARGE:
        return styles.large;
      default:
        return styles.medium;
    }
  };

  const getTextSize = (): TextSize => {
    switch (size) {
      case AvatarSize.XSMALL:
        return TextSize.XXXSMALL;
      case AvatarSize.SMALL:
        return TextSize.XSMALL;
      case AvatarSize.LARGE:
        return TextSize.XLARGE;
      default:
        return TextSize.MEDIUM;
    }
  };

  const getColourClass = (): AvatarPlaceholderColorClass => {
    return isRandomColor ? randomColorRef.current : colorClass;
  };

  const getBorderThicknessClass = (): string => {
    switch (borderThickness) {
      case AvatarBorderThickness.THIN:
        return styles.thinBorder;
      default:
        return styles.thickBorder;
    }
  };

  return (
    <div className={`radius-round flex-center ${styles.avatar} ${getColourClass()} ${getSizeClass()} ${getBorderThicknessClass()}`}>
      <Text val={placeholderLetter} bold size={getTextSize()} className="content-body-white" />
    </div>
  );
}
